import { useEffect } from 'react'
import { createElement } from 'react'
import { mountNediTheme, NEDI_CONTRACT_VERSION, NEDI_UI_WEB_VERSION } from './mountNediTheme'
import AvButton from './AvButton'
import { NediScreen, NediStack, NediInline, NediPanel } from './NediLayout'
import './NediBrowserGallery.css'

const STAT_ITEMS = JSON.stringify([
  { label: 'Lugares', value: '5' },
  { label: 'Check-ins', value: '5' },
  { label: 'Notas demo', value: '5' },
])

/**
 * Browser gallery harness (plano 0.3 web) — same synthetic dataset labels as
 * iOS NediGalleryView. Open with ?nediGallery=1.
 */
export default function NediBrowserGallery() {
  useEffect(() => {
    mountNediTheme({ activateSuiteGlass: true })
  }, [])

  return (
    <div className="nedi-browser-gallery atlas-vivo-scope" data-testid="nedi-browser-gallery">
      <NediScreen>
        <NediStack gap="hero">
          <header className="nedi-gallery-banner" aria-label="Nedi gallery browser harness">
            <p className="nedi-gallery-eyebrow">Nedi gallery · browser harness</p>
            <p>
              nedi-ui-web {NEDI_UI_WEB_VERSION} · contractVersion {NEDI_CONTRACT_VERSION}
            </p>
            <p className="nedi-gallery-note">
              Vendored tarball inside NewApp · Timeline / Percurso / Atlas Vivo · Abr/2042
              sintético
            </p>
          </header>

          <NediPanel>
            {createElement('nedi-page-header', {
              title: 'Timeline',
            })}
            <p className="nedi-gallery-kicker">Percurso · Atlas Vivo · Cidade Exemplo (fictícia)</p>
            <p className="nedi-gallery-fixture-mark">
              Fixture sintético Abr/2042 · sem dados pessoais · músicas demo 17
            </p>
          </NediPanel>

          <section aria-labelledby="nedi-gallery-snapshot">
            <h2 id="nedi-gallery-snapshot">Snapshot fixture</h2>
            <p>Dados alinhados ao aceite Atlas/Dados (iOS harness)</p>
            <NediInline className="nedi-gallery-stats">
              {createElement('nedi-stat-strip', { items: STAT_ITEMS })}
            </NediInline>
          </section>

          <section aria-labelledby="nedi-gallery-controls">
            <h2 id="nedi-gallery-controls">Controls</h2>
            <NediInline className="nedi-gallery-controls">
              <AvButton variant="primary">Primary</AvButton>
              <AvButton variant="secondary">Secondary</AvButton>
              <AvButton variant="ghost">Ghost</AvButton>
              <AvButton variant="destructive">Destructive</AvButton>
            </NediInline>
          </section>

          <section aria-labelledby="nedi-gallery-rows">
            <h2 id="nedi-gallery-rows">Rows</h2>
            <NediStack gap="row">
              {createElement('nedi-list-row', {
                title: 'Café Horizonte — FICTÍCIO',
                subtitle: 'Café demonstrativo · fixture',
              })}
              {createElement('nedi-list-row', {
                title: 'Biblioteca Aurora — FICTÍCIA',
                subtitle: 'Biblioteca de teste · fixture',
              })}
            </NediStack>
          </section>

          <section aria-labelledby="nedi-gallery-empty">
            <h2 id="nedi-gallery-empty">Empty</h2>
            {createElement(
              'nedi-card',
              null,
              createElement('strong', null, 'Empty-state sample'),
              createElement(
                'p',
                null,
                'Conectar fonte ou usar TIMELINE_MAP_FIXTURE=1 no iOS.',
              ),
            )}
          </section>
        </NediStack>
      </NediScreen>
    </div>
  )
}
